import React, { useContext } from "react";
import { Language, TText } from "api/type";
import { LanguageContext } from "contexts";

const text: TText = {
  text1: {
    en: "To get ready to pose, please make sure your area of interest is uncovered, find a bright space, and face toward a light source.",
    es: "Para prepararte para posar, asegúrate de que tu área de interés esté descubierta, busca un espacio luminoso y mira hacia una fuente de luz.",
  },
  image: {
    en: "https://clinic-os.com/flow-assets%2Fbody-scan-instructions%2Fscan-instructions2.png",
    es: "https://clinic-os.com/flow-assets/body-scan-instructions/scan-instructions2-es.png",
  },
};

const Screen2: React.FC = () => {
  const language = useContext<Language>(LanguageContext)[0];

  if (!language) return null;

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        height: "auto",
      }}
    >
      <img
        src={text.image[language]}
        alt=""
        style={{
          width: "auto",
          height: "auto",
          maxWidth: "322px",
          aspectRatio: "1",
        }}
      />
      <p
        style={{
          fontSize: "14px",
          color: "black",
          fontWeight: 400,
          width: "322px",
        }}
      >
        {text.text1[language]}
      </p>
    </div>
  );
};

export default Screen2;
